<span class='cell-real-estate-mortgages-calculator_legend_item'>
	<span class='cell-real-estate-mortgages-calculator_legend_item-name'><%= name %></span>
	<span class='cell-real-estate-mortgages-calculator_legend_item-value'><%= y %></span>
  <% if(key === "stamp_duties") { %>
    <% if(show_stamp_duties_sub_item) { %>
      <i class="fa fa-angle-up icon"></i>
    <% } else { %>
      <i class="fa fa-angle-down icon"></i>
    <% } %>
  <% } %>
</span>
<% if(show_stamp_duties_sub_item && key === "stamp_duties") { %>
  <span class='cell-real-estate-mortgages-calculator_legend_sub_item first-item'>
    <span >
      <%= I18n.t('concepts.real_estate.mortgages.calculator.data.labels.ad_valorem_stamp_duty') %>
    </span>
    <span class='cell-real-estate-mortgages-calculator_legend_sub_item-value'><%= ad_valorem_stamp_duty %></span>
  </span>
<% } %>

